export const state = {
  fleetGroup: null,
}

export const mutations = {
  SET_FLEET_GROUP(state, value) {
    state.fleetGroup = value
  },
}

export const actions = {
  setFleetGroup({ commit }, value) {
    commit('SET_FLEET_GROUP', value)
  },
}

export const getters = {
  getFleetGroup: (state) => state.fleetGroup,
}
